export default __webpack_public_path__ + "assets/white-jersey-d82e340c8abf6effcefadd7c6288e8f4.png";